import React from 'react';
import Layout from '../components/Layout';

export default function PrivacyPolicy() {
  return (
    <Layout>
      <div className="page-banner">
        <h1>Privacy Policy</h1>
      </div>
      <div className="main-content">
        <div className="policy-content">
          <h2>PRIVACY POLICY</h2>
          <p className="updated">Last Updated: May 21, 2026</p>

          <p>
            Smart Device Assistant ("we," "our," or "us") respects your privacy. This Privacy Policy explains how
            we collect, use, and protect information on our website.
          </p>

          <h3>Information We Collect:</h3>
          <ul>
            <li>Non-personal information such as device type, browser, and pages visited.</li>
            <li>Cookies and similar tracking technologies to improve site functionality and ads.</li>
            <li>Personal information only if you voluntarily submit it, such as through contact forms, chat features, or other direct communications.</li>
          </ul>

          <h3>How We Use Information:</h3>
          <ul>
            <li>To provide and improve our content.</li>
            <li>To respond to inquiries submitted via contact forms or chat.</li>
            <li>To analyze website usage.</li>
            <li>To display relevant ads through third-party networks, including Google Ads.</li>
          </ul>

          <h3>Third-Party Services:</h3>
          <p>
            We use services such as Google Analytics and Google Ads, which may collect data in accordance with their
            own privacy policies. For more information, please see{' '}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">Google Privacy Policy</a>.
          </p>

          <h3>Cookies and Tracking:</h3>
          <p>
            Cookies help us deliver a better user experience. You can disable cookies in your browser settings,
            though some site features may not function properly.
          </p>

          <h3>Data Security:</h3>
          <p>We take reasonable measures to protect data, but cannot guarantee absolute security.</p>

          <h3>Children's Privacy:</h3>
          <p>Our website is not directed at children under 13.</p>

          <h3>Changes to this Policy:</h3>
          <p>We may update this Privacy Policy periodically. Please check this page for the latest version.</p>
        </div>
      </div>
    </Layout>
  );
}
